import React from 'react';
import { Modal, Button, ButtonGroup, Text } from '@nike/eds';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { translations as ts } from './i18n';
import styles from './remove.module.css';

interface RemoveFamilyProps {
  isOpen: boolean;
  familyMemberName: string;
  visitorId?: number;
  onKeep: () => void;
  onRemove: () => void;
  onDismiss?: () => void;
}

export const RemoveFamily: React.FC<RemoveFamilyProps> = ({
  isOpen,
  familyMemberName,
  onKeep,
  onRemove,
  onDismiss,
}) => {
  const { i18nString } = useI18nContext();

  const footer = (
    <ButtonGroup className="eds-flex eds-flex--justify-content-center eds-spacing--mt-20">
      <Button
        variant="primary"
        onClick={onKeep}
        data-testid="keep-family-btn"
        className={`txt_uppercase ${styles.btn}`}
      >
        {i18nString(ts.CANCEL_FAMILY_MODAL_KEEP)}
      </Button>
      <Button
        variant="primary"
        onClick={onRemove}
        data-testid="remove-family-btn"
        className={`txt_uppercase ${styles.btn}`}
      >
        {i18nString(ts.CANCEL_FAMILY_MODAL_REMOVE)}
      </Button>
    </ButtonGroup>
  );

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss || onKeep}
      headerSlot={
        <Text as="h1" className="txt-align-center txt_uppercase">
          {i18nString(ts.FAMILY_MODAL_REMOVE_FAMILY)}
        </Text>
      }
      id="remove-family-modal"
      footerSlot={footer}
      data-testid="remove-family-modal"
    >
      {' '}
      <div
        className={`eds-flex eds-flex--justify-content-center eds-spacing--p-24 ${styles.modalBody}`}
      >
        <Text as="h3" className="eds-spacing--mb-12 txt_uppercase txt-align-center">
          {i18nString(ts.CANCEL_FAMILY_MODAL_INFORM)}
          <br />
          <h3 className={styles.txtname}>{familyMemberName}</h3>
        </Text>
      </div>
    </Modal>
  );
};

export default RemoveFamily;
